import { render } from "./TradeSettingsPopover.vue?vue&type=template&id=89238c80&ts=true"
import script from "./TradeSettingsPopover.vue?vue&type=script&lang=ts"
export * from "./TradeSettingsPopover.vue?vue&type=script&lang=ts"

import "./TradeSettingsPopover.vue?vue&type=style&index=0&id=89238c80&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__